import { useEffect } from 'react'
import { saveTikTokToken } from '../../service/tiktok'
import useTranslation from '../../hooks/useTranslation'

export const TiktokSuccess = () => {
  const { t } = useTranslation()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const accessToken = urlParams.get('access_token')
    const refreshToken = urlParams.get('refresh_token')
    const expiresIn = urlParams.get('expires_in')

    if (accessToken && refreshToken && expiresIn) {
      const tokenData = {
        access_token: accessToken,
        refresh_token: refreshToken,
        expires_in: parseInt(expiresIn),
      }

      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'TIKTOK_AUTH_SUCCESS',
            tokenData,
          },
          window.location.origin
        )
        window.close()
      } else {
        localStorage.setItem('tiktok_token', JSON.stringify(tokenData))
        saveTikTokToken(tokenData.access_token)
        window.location.href = '/tiktok'
      }
    } else {
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'TIKTOK_AUTH_ERROR',
            error: 'Missing token data',
          },
          window.location.origin
        )
        window.close()
      } else {
        window.location.href = '/tiktok?error=auth_failed'
      }
    }
  }, [])

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500 mx-auto mb-4"></div>
        <p className="text-gray-600">{t('tiktok.messages.authProcessing')}</p>
      </div>
    </div>
  )
}
